import React, { useState, useEffect } from "react";
import Sidebar from "../PPT/Sidebar";
import { MAX_TITLE_LENGTH } from "../../data/constant";

function EditFirstSlide({ isOpen, setIsOpen, activeSlideConfig, onEditFirstSlide }) {
  console.info("EditFirstSlide", activeSlideConfig);
 
  const [titleText, setTitleText] = useState("");
  const [initialTitle, setInitialTitle] = useState("");

  useEffect(() => {
    if (isOpen && activeSlideConfig?.title) {
      setTitleText(activeSlideConfig.title);
      setInitialTitle(activeSlideConfig.title);
    }
  }, [isOpen, activeSlideConfig]);

  useEffect(() => {
    if (!isOpen) {
      setTitleText("");
      setInitialTitle("");
    }
  }, [isOpen]);

  const handleTextChange = (e) => {
    setTitleText(e.target.value);
  };

  const isTextChanged = titleText !== initialTitle;

  return (
    <Sidebar
      open={isOpen}
      setOpen={setIsOpen}
      isLoading={false}
      title="Edit Slide 1"
      onConfirm={() => {
        console.info("Updating first slide title");
        onEditFirstSlide({
          ...activeSlideConfig,
          title: titleText
        });
        setIsOpen(false);
      }}
      disabled={!isTextChanged}
      rightCTA="Update Slide"
    >
      <div>
        <h2 className="text-base font-bold mb-4">Title</h2>
        <input
          type="text"
          maxLength={MAX_TITLE_LENGTH}
          value={titleText}
          onChange={handleTextChange}
          className="w-full p-2 border rounded-md"
          placeholder="Enter slide title"
        />
      </div>
    </Sidebar>
  );
}

export default EditFirstSlide;
